
















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
    components: {},
})
export default class BannerImgUploader extends Vue {
    uploadFile() {
        (this.$refs.bannerImg as HTMLElement).click();
    }

    onFileChange(event: { target: { files: any } }) {
        this.inputFile(event.target.files);
    }

    inputFile(files: File) {

    }
}
